import LocalizedStrings from 'localized-strings';

const locales = new LocalizedStrings({
  en: {
    confirm: 'Confirm',
    errorMessage:
      'An error has occurred. Please try again and if the problem persists, please contact us.',
    inputLabel: 'Actual URSSAF settlement amount',
    successMessage:
      'Your URSSAF installment has been marked as successfully paid!',
    title: 'Confirm payment of your URSSAF installment',
  },
  fr: {
    confirm: 'Confirmer',
    errorMessage:
      'Une erreur est survenue. Réessayez et si le problème persiste, contactez-nous.',
    inputLabel: 'Montant réel du règlement URSSAF',
    successMessage:
      'Votre échéance URSSAF a été marquée comme payée avec succès !',
    title: 'Confirmer le règlement de votre échéance URSSAF',
  },
} as const);

export default locales;
